var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'is-disabled': _vm.isDisabled },staticStyle:{"display":"none"},on:{"click":function($event){return _vm.executeAction()}}},[_c('ed-icon',{attrs:{"icon":_vm.tool.icon,"title":_vm.tool.tooltip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }